<template>
  <div
    class="bg-background flex flex-col overflow-hidden rounded-[2rem] border border-gray-300 p-4"
  >
    <div class="flex items-center justify-between">
      <AppDrawerHeader>Tip</AppDrawerHeader>
      <FormInputPrice
        v-model="priceInMinorUnits"
        class="mb-2 w-40"
        name="total"
        placeholder="10.00"
      />
    </div>

    <p class="mt-4 px-4 text-center text-lg font-normal">
      Would you like to leave a tip?
    </p>
    <div
      class="flex flex-1 flex-col items-stretch justify-end"
    >
      <div class="space-y-4 p-4">
        <template
          v-for="option in options"
          :key="option.label"
        >
          <AppActionButtonSecondary
            class="block w-full py-4"
          >
            {{ option.label }}
          </AppActionButtonSecondary>
        </template>
        <AppActionButtonPrimary class="block w-full py-4">
          Custom Amount
        </AppActionButtonPrimary>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
const props = defineProps<{
  gratuityOptionsList: Array<number>
}>()

const { formatToMerchantCurrencyString } = useCurrency()
const priceInMinorUnits = ref(1000)

const getGratuity = (percentage: number) =>
  computed(() =>
    priceInMinorUnits.value
      ? Math.ceil(
          (priceInMinorUnits.value * percentage) / 100
        )
      : 0
  )

const DEFAULT_GRATUITY_PERCENTAGES = [5, 10, 15, 20]

const getGratuityOptions = (
  gratuityPercentages: Array<number>
) =>
  gratuityPercentages
    .filter((percentage) => percentage !== 0)
    .map((percentage) => {
      return {
        label: `${percentage}%  - ${formatToMerchantCurrencyString(
          getGratuity(percentage).value
        )}`,
        value: getGratuity(percentage).value,
      }
    })

const options = computed(() => [
  {
    label: "No Thanks",
    value: 0,
  },
  ...(props.gratuityOptionsList.every(
    (percentage) => percentage === 0
  )
    ? getGratuityOptions(DEFAULT_GRATUITY_PERCENTAGES)
    : getGratuityOptions(props.gratuityOptionsList)),
])
</script>
